const SUPABASE_URL = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const AUTH_ENDPOINT = `${SUPABASE_URL}/functions/v1/admin-auth`;
const SESSION_KEY = 'admin_session_token';

interface LoginResponse {
  success: boolean;
  sessionToken?: string;
  expiresAt?: string;
  admin?: {
    admin_id: string;
    username: string;
  };
  error?: string;
}

interface VerifyResponse {
  success: boolean;
  admin?: {
    admin_id: string;
    username: string;
  };
  error?: string;
}

export const login = async (username: string, password: string): Promise<LoginResponse> => {
  try {
    const response = await fetch(AUTH_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: 'login',
        username,
        password,
      }),
    });

    const data = await response.json();

    if (data.success && data.sessionToken) {
      localStorage.setItem(SESSION_KEY, data.sessionToken);
    }

    return data;
  } catch (error) {
    return {
      success: false,
      error: 'Network error. Please try again.',
    };
  }
};

export const verifySession = async (): Promise<VerifyResponse> => {
  const sessionToken = localStorage.getItem(SESSION_KEY);

  if (!sessionToken) {
    return { success: false, error: 'No session found' };
  }

  try {
    const response = await fetch(AUTH_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: 'verify',
        sessionToken,
      }),
    });

    const data = await response.json();

    if (!data.success) {
      localStorage.removeItem(SESSION_KEY);
    }

    return data;
  } catch (error) {
    return {
      success: false,
      error: 'Network error',
    };
  }
};

export const logout = async (): Promise<void> => {
  const sessionToken = localStorage.getItem(SESSION_KEY);

  if (sessionToken) {
    try {
      await fetch(AUTH_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'logout',
          sessionToken,
        }),
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
  }

  localStorage.removeItem(SESSION_KEY);
};

export const isAuthenticated = (): boolean => {
  return !!localStorage.getItem(SESSION_KEY);
};